module.exports = __webpack_public_path__ + "img/bg-blue.5fa4542b.png";